import { callEndpoint, checkClientToken } from '../backend';

export const getReminders = async () => {
  const reminders = await callEndpoint(
    callEndpoint.endpoints.getReminders,
  );
  return reminders;
};

export const setReminder = async (label, reminderType, expiryDate) => {
  await callEndpoint(
    callEndpoint.endpoints.submitReminder,
    {
      label,
      reminderType,
      expiryDate,
    },
  );
  return checkClientToken();
};

export const editReminder = async (id, label, reminderType, expiryDate) => {
  await callEndpoint(
    callEndpoint.endpoints.editReminder,
    {
      id,
      label,
      reminderType,
      expiryDate,
    },
  );
  return checkClientToken();
};

export const deleteReminder = async (id) => {
  await callEndpoint(
    callEndpoint.endpoints.deleteReminder,
    {
      id,
    },
  );
  return checkClientToken();
};

export const initialize = () => {

};
